export const content = {
    domain: "CashNetUSA",
    footer: "cashneltusa.com",
    title1: "Bad Credit? Get Your Online Loan Today!",
  };
  